import { PriceModel } from 'types/purchasing';
import { formatPrice } from 'utils/functions';
import { getTrackingStrings } from 'constants/trackingStrings';

const trackingStrings = getTrackingStrings();

export const getCopy = (priceModel: PriceModel | undefined) => ({
  toggles: [
    {
      name: 'mslResetOnReceipt',
      label: 'MSL Reset on Receipt',
      description: {
        true: `When a Stock Lot is received at Cofactr, if it is MSL 2+ and needs to have its MSL reset, it will be automatically routed for baking. Our baking procedure is per J-STD-033 using a 40C <1% humidity baking dry cabinet with resealing in a vacuum vapor barrier ESD bag with a desiccant pouch and humidity indicator card.${
          priceModel
            ? ` A ${formatPrice(
                priceModel.handlingHandlingMslreset,
                2
              )} fee will apply for each MSL reset bake.`
            : ''
        }`,
        false:
          'Stock Lots received at Cofactr will be placed in storage, and you can manually request MSL Resets from within the Cofactr platform. An MSL Reset bake can take up to 2 weeks, so we recommend setting this to automatically happen to ensure your stock is always ready for production.',
      },
    },
    {
      name: 'lcrInspectionOnReceipt',
      label: 'LCR Inspection on Receipt',
      description: {
        true: `When a Stock Lot is received at Cofactr, if it is a passive component, we will perform an LCR (inductance, capacitance, resistance) measurement of a sample part and a comparison of measurement against key value and tolerance specified in the datasheet.${
          priceModel
            ? ` A ${formatPrice(
                priceModel.handlingHandlingInspectionLcr,
                2
              )} fee will apply for each inspection.`
            : ''
        }`,
        false:
          'Stock Lots received at Cofactr will be placed in storage, and you can manually request an LCR Inspection from within the Cofactr platform. Even parts purchased from leading distributors are sometimes incorrect, so we recommend automatic LCR inspections unless you are confident that your manufacturer is performing one for you.',
      },
    },
    {
      name: 'dimensionalInspectionOnReceipt',
      label: 'Dimensional Inspection on Receipt',
      description: {
        true: `When a Stock Lot is received at Cofactr,  a Dimensional measurement of key part features as defined by the manufacturer datasheet and comparison of measurements against values specified in the datasheet will be performed.${
          priceModel
            ? ` A ${formatPrice(
                priceModel.handlingHandlingInspectionDimensional,
                2
              )} fee will apply for each inspection.`
            : ''
        }`,
        false:
          'Stock Lots received at Cofactr will be placed in storage, and you can manually request a Dimensional Inspection from within the Cofactr platform. Even parts purchased from leading distributors are sometimes incorrect, so automatic Dimensional inspections can help avoid delays related to incorrect parts at your contract manufacturer.',
      },
    },
    {
      name: 'inspectionPhotoOnReceipt',
      label: 'Microscope Inspection Photo on Receipt',
      description: {
        true: `When a Stock Lot is received at Cofactr,  we will capture 4K digital microscope images of the top and bottom surfaces of a single sample part from this stock lot including part markings. You will be able to view those images within the Cofactr platform.${
          priceModel
            ? ` A ${formatPrice(
                priceModel.handlingHandlingInspectionPhoto,
                2
              )} fee will apply for each inspection.`
            : ''
        }`,
        false:
          'Stock Lots received at Cofactr will be placed in storage, and you can manually request an Inspection Photo from within the Cofactr platform.',
      },
    },
    {
      name: 'packagePhotoOnReceipt',
      label: 'Package Photo on Receipt',
      description: {
        true: `When a Stock Lot is received at Cofactr, we will capture images of the top and bottom sides of this stock lot’s packaging including any supplier labels. You will be able to view those images within the Cofactr platform.${
          priceModel
            ? ` A ${formatPrice(
                priceModel.handlingHandlingPackagePhoto
              )} fee will apply for each stock lot.`
            : ''
        }`,
        false:
          'Stock Lots received at Cofactr will be placed in storage, and you can manually request a Packaging Photo from within the Cofactr platform.',
      },
    },
  ],
  defaultShippingMethod: {
    name: 'defaultShippingMethod',
    label: 'Shipping Preferences',
    description:
      'This will be the default shipping option for all shipments created for this organization.',
  },
  trackingNamePreferences: trackingStrings.orgPreferences,
});
